import { NewTabLink } from "../UI/NewTabLink";

export function IsRetHOMEFees(props: { Campus: string, AcadYearLabel: string }) {
    const CampusLink = props.Campus.replaceAll("Campus", "").replaceAll(" ", "").toLowerCase();

    const linkURL = "https://www.essex.ac.uk/life/accommodation/apply/returning-students/" + CampusLink;

    return <div className="OtherData_Container">
        <fieldset className="OtherData">
            <legend>{props.AcadYearLabel} accommodation applications</legend>

            <h2>Returning home fee-paying undergraduate students ({props.Campus})</h2>

            <p>Please read all of the information on our main Returning Students pages before booking accommodation:</p>

            <p><NewTabLink to={linkURL}>{linkURL}</NewTabLink>.</p>
        </fieldset>
    </div>;
}